// removed by extract-text-webpack-plugin
module.exports = {"list-video":"list-video","video-item":"video-item","video-item__wrap":"video-item__wrap","video-item__icon":"video-item__icon","svg-icon":"svg-icon","video-item__text":"video-item__text","video-item-popup":"video-item-popup","sk-fading-circle":"sk-fading-circle"};


//////////////////
// WEBPACK FOOTER
// ../css/components/_video.scss
// module id = 290
// module chunks = 0